import { store } from '../../../../store';
import { selectAktSeed } from '../../../../reducers/selectors/metadata';
import { getMatchPlaybackService } from 'react/api/services/sports';
import { fetchPlaybackServerIp } from 'action-creators/serverip';

const getProtectedPlay = (groupId, streamType) => {
  const epgLineUp = store.getState()?.EpgLineUp?.data;
  const currentChannel = epgLineUp?.find(
    channel => channel?.group_id === groupId,
  );
  const protectedPlayUrl =
    currentChannel?.group?.common?.extendedcommon?.media?.language?.options
      ?.option?.[0]?.protected_play?.[
      (streamType?.includes('dashwv') ? 'dashwv' : 'hlsfps')
    ] || null;

  return protectedPlayUrl;
};

const getAktSeed = async (groupId = null, streamType = 'dashwv') => {
  try {
    const state = store.getState();
    const aktSeedConfig = selectAktSeed(state);

    if (!aktSeedConfig?.enable || !groupId) return null;
    const fallbackIpUrl = aktSeedConfig?.client_ip_fallback_url ?? null;
    const protectedPlayUrl = getProtectedPlay(groupId, streamType);
    const keyAktSeed = await fetchPlaybackServerIp(
      protectedPlayUrl ? protectedPlayUrl : fallbackIpUrl,
    );

    return keyAktSeed;
  } catch (error) {
    return null;
  }
};

/**
 * Wrapper de `getMatchPlaybackService` con reintentos.
 *
 * Mismo contrato que el servicio original (devuelve la response de axios).
 * Si todos los intentos fallan, throw del último error capturado para que
 * el callsite lo maneje en su `try/catch` existente.
 *
 * Sin AbortSignal por diseño: los callsites de WCMatchDetails ya usan el
 * patrón `let cancelled = false` y descartan el resultado tras el await.
 * Mantener este helper "atómico" (todos los intentos dentro de una sola
 * promesa) preserva ese patrón sin cambios.
 *
 * Delay entre intentos: 1s (mismo que el loop de `player.load` en
 * WCPlaybackBlock para consistencia).
 */

export const getMatchPlaybackWithRetry = async (
  leagueId,
  matchId,
  deviceParams,
  attempts,
) => {
  const totalAttempts = Math.max(1, attempts || 1);
  let lastErr;
  for (let i = 0; i < totalAttempts; i++) {
    try {
      const key_akt_seed = await getAktSeed(
        deviceParams?.matchPlayerGroupId || null,
        deviceParams?.streamType,
      );
      return await getMatchPlaybackService(leagueId, matchId, {
        ...deviceParams,
        key_akt_seed,
      });
    } catch (err) {
      lastErr = err;
      
      if (i < totalAttempts - 1) {
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
    }
  }
  throw lastErr;
};

export default getMatchPlaybackWithRetry;
